import { Routes, Route, NavLink } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import ContactDetail from './pages/ContactDetail';
import GlobalSearch from './pages/GlobalSearch';

/**
 * Main App Component
 * 
 * Provides routing and navigation for the frontend.
 * Requirements: 8.1, 8.3, 8.4, 8.5, 8.6
 */
export default function App() {
  return (
    <div className="app-container">
      <nav className="nav">
        <span className="nav-brand">ActuallyHelpfulAssistant</span>
        <div className="nav-links">
          <NavLink 
            to="/" 
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          >
            Dashboard
          </NavLink>
          <NavLink 
            to="/search" 
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          >
            Search
          </NavLink>
        </div>
      </nav>
      
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/contact/:contactId" element={<ContactDetail />} />
          <Route path="/search" element={<GlobalSearch />} />
        </Routes>
      </main>
    </div>
  );
}
